export default __webpack_public_path__ + "static/media/Stamina Potion.ca3407f8.jpg";